import logoOspedaliAsl1 from "../../styles/images/loghi/asl1.png";
import logoOspedaliAsl2 from "../../styles/images/loghi/asl2.png";
import logoOspedaliAsl3 from "../../styles/images/loghi/asl3.png";
import logoOspedaliAsl4 from "../../styles/images/loghi/asl4.png";
import logoOspedaliAsl5 from "../../styles/images/loghi/asl5.png";
import logoOspedaleGalliera from "../../styles/images/loghi/galliera.png";
import logoOspedaleSanMartino from "../../styles/images/loghi/sanmartino.png";
import logoOspedaleGaslini from "../../styles/images/loghi/gaslini.png";
import logoOspedaleEvangelico from "../../styles/images/loghi/evangelico.png";
import logoOspedaleVillaScassi from "../../styles/images/loghi/villaScassi.png";
import {
  PATH_IMPERIA,
  PATH_SANREMO,
  PATH_BORDIGHERA,
  PATH_SANTA_CORONA,
  PATH_SANTA_MARIA_MISERICORDIA,
  PATH_SAN_GIUSEPPE,
  PATH_SAN_PAOLO,
  PATH_LA_COLLETTA,
  PATH_MICONE,
  PATH_VILLA_SCASSI,
  PATH_GALLINO,
  PATH_RIBOLI,
  PATH_SESTRI_LEVANTE,
  PATH_MONTALLEGRO,
  PATH_ASL5,
  PATH_GALLIERA,
  PATH_SAN_MARTINO,
  PATH_GASLINI,
  PATH_EVANGELICO,
} from "../../path";
import {
  ID_IMPERIA,
  ID_SANREMO,
  ID_BORDIGHERA,
  ID_SANTA_CORONA,
  ID_SANTA_MARIA_MISERICORDIA,
  ID_SAN_GIUSEPPE,
  ID_SAN_PAOLO,
  ID_LA_COLLETTA,
  ID_MICONE,
  ID_VILLA_SCASSI,
  ID_GALLINO,
  ID_RIBOLI,
  ID_SESTRI_LEVANTE,
  ID_MONTALLEGRO,
  ID_LA_SPEZIA,
  ID_LEVANTO,
  ID_SARZANA,
  ID_GALLIERA,
  ID_GASLINI,
  ID_EVANGELICO_CASTELLETTO,
  ID_EVANGELICO_VOLTRI,
} from "../../modules/common";

// ASL1 IMPERIESE
const imperiaInfo = {
  href: PATH_IMPERIA,
  id: "ospedaliAsl1",
  alt: "Logo Ospedali Asl 1",
  src: logoOspedaliAsl1,
};

const sanremoInfo = {
  href: PATH_SANREMO,
  id: "ospedaliAsl1",
  alt: "Logo Ospedali Asl 1",
  src: logoOspedaliAsl1,
};

const bordigheraInfo = {
  href: PATH_BORDIGHERA,
  id: "ospedaliAsl1",
  alt: "Logo Ospedali Asl 1",
  src: logoOspedaliAsl1,
};

// ASL2 SAVONESE
const santaCoronaInfo = {
  href: PATH_SANTA_CORONA,
  id: "ospedaliAsl2",
  alt: "Logo Ospedali Asl 2",
  src: logoOspedaliAsl2,
};

const santaMariaMisericordiaInfo = {
  href: PATH_SANTA_MARIA_MISERICORDIA,
  id: "ospedaliAsl2",
  alt: "Logo Ospedali Asl 2",
  src: logoOspedaliAsl2,
};

const sanGiuseppeInfo = {
  href: PATH_SAN_GIUSEPPE,
  id: "ospedaliAsl2",
  alt: "Logo Ospedali Asl 2",
  src: logoOspedaliAsl2,
};

const sanPaoloInfo = {
  href: PATH_SAN_PAOLO,
  id: "ospedaliAsl2",
  alt: "Logo Ospedali Asl 2",
  src: logoOspedaliAsl2,
};

// ASL3 GENOVESE
const laCollettaInfo = {
  href: PATH_LA_COLLETTA,
  id: "ospedaliAsl3",
  alt: "Logo Ospedali Asl 3",
  src: logoOspedaliAsl3,
};

const miconeInfo = {
  href: PATH_MICONE,
  id: "ospedaliAsl3",
  alt: "Logo Ospedali Asl 3",
  src: logoOspedaliAsl3,
};

const gallinoInfo = {
  href: PATH_GALLINO,
  id: "ospedaliAsl3",
  alt: "Logo Ospedali Asl 3",
  src: logoOspedaliAsl3,
};

// ASL4 CHIAVARESE
const riboliInfo = {
  href: PATH_RIBOLI,
  id: "ospedaliAsl4",
  alt: "Logo Ospedali Asl 4",
  src: logoOspedaliAsl4,
};

const sestriLevanteInfo = {
  href: PATH_SESTRI_LEVANTE,
  id: "ospedaliAsl4",
  alt: "Logo Ospedali Asl 4",
  src: logoOspedaliAsl4,
};

const montallegroInfo = {
  href: PATH_MONTALLEGRO,
  id: "ospedaliAsl4",
  alt: "Logo Ospedali Asl 4",
  src: logoOspedaliAsl4,
};

// ASL5
const asl5Info = {
  href: PATH_ASL5,
  id: "ospedaliAsl5",
  alt: "Logo Ospedali Asl 5",
  src: logoOspedaliAsl5,
};

// GALLIERA
const gallieraInfo = {
  href: PATH_GALLIERA,
  id: "ospedaleGalliera",
  alt: "Logo Ospedale Galliera",
  src: logoOspedaleGalliera,
};

// S.MARTINO
const sanMartinoInfo = {
  href: PATH_SAN_MARTINO,
  id: "ospedaleSanMartino",
  alt: "Logo Ospedale San Martino",
  src: logoOspedaleSanMartino,
};

// VILLA SCASSI
const villaScassiInfo = {
  href: PATH_VILLA_SCASSI,
  id: "ospedaleVillaScassi",
  alt: "Logo Ospedale Villa Scassi",
  src: logoOspedaleVillaScassi,
};

// GASLINI
const gasliniInfo = {
  href: PATH_GASLINI,
  id: "ospedaleGaslini",
  alt: "Logo Ospedale Gaslini",
  src: logoOspedaleGaslini,
};

// EVANGELICO
const evangelicoInfo = {
  href: PATH_EVANGELICO,
  id: "ospedaleEvangelico",
  alt: "Logo Ospedale Evangelico",
  src: logoOspedaleEvangelico,
};

export const ottieniInfoStruttura = (idStruttura) => {
  let info = null;
  switch (idStruttura) {
    case ID_IMPERIA:
      info = imperiaInfo;
      break;
    case ID_SANREMO:
      info = sanremoInfo;
      break;
    case ID_BORDIGHERA:
      info = bordigheraInfo;
      break;
    case ID_SANTA_CORONA:
      info = santaCoronaInfo;
      break;
    case ID_SANTA_MARIA_MISERICORDIA:
      info = santaMariaMisericordiaInfo;
      break;
    case ID_SAN_GIUSEPPE:
      info = sanGiuseppeInfo;
      break;
    case ID_SAN_PAOLO:
      info = sanPaoloInfo;
      break;
    case ID_LA_COLLETTA:
      info = laCollettaInfo;
      break;
    case ID_MICONE:
      info = miconeInfo;
      break;
    case ID_VILLA_SCASSI:
      info = villaScassiInfo;
      break;
    case ID_GALLINO:
      info = gallinoInfo;
      break;
    case ID_RIBOLI:
      info = riboliInfo;
      break;
    case ID_SESTRI_LEVANTE:
      info = sestriLevanteInfo;
      break;
    case ID_MONTALLEGRO:
      info = montallegroInfo;
      break;
    case ID_LA_SPEZIA:
    case ID_LEVANTO:
    case ID_SARZANA:
      info = asl5Info;
      break;
    case ID_GALLIERA:
      info = gallieraInfo;
      break;
    case ID_GASLINI:
      info = gasliniInfo;
      break;
    case ID_EVANGELICO_CASTELLETTO:
    case ID_EVANGELICO_VOLTRI:
      info = evangelicoInfo;
      break;
    default:
      info = sanMartinoInfo;
  }
  return info;
};
